// authUtils.js (create a new file for utility functions)
export const isAuthenticated = () => {
    const accessToken = localStorage.getItem('accessToken');
    return !!accessToken; // Return true if the token exists, otherwise false
};